import { ArrowBackIosNewIcon } from '@assets/icons';
import { Box, IconButton, Link, Typography } from '@mui/material';
import Divider from '@mui/material/Divider/Divider';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Breadcrumb.scss';

interface BreadcrumbNav {
  title: string;
  detail?: string;
}

interface BreadcrumbProps {
  title?: string;
  detail?: string;
  navigation?: BreadcrumbNav[];
  children?: React.ReactNode;
  onBack?: () => void;
}

const AppBreadcrumb: FC<BreadcrumbProps> = ({
  title = '',
  children,
  detail,
  navigation = [],
  onBack,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const hasNav = useMemo(() => !!navigation.length, []);

  return (
    <div className='Breadcrumb'>
      <div className='Breadcrumb__wrapper'>
        <Box display='flex'>
          {hasNav && (
            <IconButton
              edge='start'
              className='BreadcrumbBack'
              onClick={() => {
                navigate(-1);
              }}
            >
              <ArrowBackIosNewIcon color='primary' />
            </IconButton>
          )}
          <Box className='BreadcrumbContent'>
            <Box display='flex'>
              {navigation.map((pr, idx) => (
                <Box key={idx} className='BreadcrumbContentNav'>
                  <Link
                    component='button'
                    type='button'
                    underline='none'
                    onClick={() => {
                      if (onBack) onBack();
                      else navigate(idx - navigation.length);
                    }}
                  >
                    {t(pr.title) + (pr.detail ? ' (' + pr.detail + ')' : '')}
                  </Link>
                </Box>
              ))}
            </Box>
            <Typography variant='h2' sx={{ lineHeight: hasNav ? 1 : 1.5 }}>
              {t(title) + (detail ? ' (' + detail + ')' : '')}
            </Typography>
          </Box>
        </Box>
        {children}
      </div>
      <Divider sx={{ mt: '15px', mb: '15px' }} />
    </div>
  );
};

export default AppBreadcrumb;
